export const isAdminUser = (roleValue = localStorage.getItem('UserRole')) => Number(roleValue) === 1;
